export const ActionTypes = {
    GET_NEWS_LIST_BY_ID: "GET_NEWS_LIST_BY_ID",
    GET_NEWS_SETTING_BY_ID: "GET_NEWS_SETTING_BY_ID",
    GET_ANNOUNCEMENT_BY_ID: "GET_ANNOUNCEMENT_BY_ID",
    GET_ANNOUNCEMENT_LIST: "GET_ANNOUNCEMENT_LIST",
    RESET_STATE: 'RESET_STATE'
};
